import type { FindingStatus } from "../api/types";

const CONDITION_CLASS: Record<string, string> = { Good: "good", Fair: "fair", Poor: "poor" };

export function ConditionPill({ value, provisional }: { value: string | null | undefined; provisional?: boolean }) {
  const v = value || "Not rated";
  return (
    <span className={`pill ${CONDITION_CLASS[v] ?? "unrated"}${provisional ? " provisional" : ""}`}
          title={provisional ? "Provisional: some AI findings on this road are still waiting for review" : undefined}>
      {v}{provisional ? <span className="sr-only"> (provisional)</span> : null}
    </span>
  );
}

const PRIORITY_CLASS: Record<string, string> = { "Very High": "high", High: "high", Medium: "medium", Low: "low" };

export function PriorityChip({ value }: { value: string | null | undefined }) {
  if (!value) return <span className="muted">—</span>;
  return <span className={`chip ${PRIORITY_CLASS[value] ?? "neutral"}`}>{value}</span>;
}

const STATUS_LABEL: Record<FindingStatus, string> = { verified: "Verified", unreviewed: "Unreviewed", rejected: "Rejected" };

export function StatusChip({ status }: { status: FindingStatus }) {
  return <span className={`chip ${status}`}>{STATUS_LABEL[status]}</span>;
}

export function SeverityChip({ value }: { value: string | null | undefined }) {
  if (!value || value === "Not rated") return <span className="muted">—</span>;
  return <span className={`chip ${value.toLowerCase()}`}>{value}</span>;
}

export function Confidence({ value }: { value: number | null | undefined }) {
  if (value === null || value === undefined) return <span className="muted">—</span>;
  const p = Math.round(value * 100);
  const color = p >= 50 ? "var(--good)" : p >= 25 ? "var(--fair)" : "var(--unrated)";
  return (
    <span className="conf num" title={`AI confidence ${p}%`}>
      <span className="bar"><span style={{ width: `${p}%`, background: color }} /></span>
      {p}%
    </span>
  );
}

export { CONDITION_COLOR } from "../styles/themeColors";
